import { render, staticRenderFns } from "./TabsContainer.vue?vue&type=template&id=945abc88&scoped=true&"
import script from "./TabsContainer.vue?vue&type=script&lang=ts&"
export * from "./TabsContainer.vue?vue&type=script&lang=ts&"
import style0 from "./TabsContainer.vue?vue&type=style&index=0&id=945abc88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945abc88",
  null
  
)

export default component.exports